<script>
  import CountrySelect from './CountrySelect.svelte';
  import { createEventDispatcher } from 'svelte';

  export let error = '';
  export let initialName = '';

  const dispatch = createEventDispatcher();

  let form = blank();
  let loading = false;

  function blank() {
    return { name: initialName, formed_year: '', description: '', band_logo_url: '', country: '', status: '', genres: '' };
  }

  async function submit() {
    if (!form.name.trim()) { error = 'Name is required'; return; }
    loading = true; error = '';
    try {
      const payload = { name: form.name.trim() };
      if (form.formed_year)   payload.formed_year   = Number(form.formed_year);
      if (form.description)   payload.description   = form.description.trim();
      if (form.band_logo_url) payload.band_logo_url = form.band_logo_url.trim();
      if (form.country)       payload.country       = form.country.trim();
      if (form.status)        payload.status        = form.status.trim();
      payload.genres = form.genres
        ? form.genres.split(',').map(g => g.trim()).filter(Boolean)
        : [];
      dispatch('submit', payload);
    } finally {
      loading = false;
    }
  }
</script>

<div class="inline-create-form">
  <div class="inline-create-header">
    <span>New Artist</span>
    <button type="button" class="inline-create-close" on:click={() => dispatch('cancel')}>✕</button>
  </div>
  {#if error}<div class="inline-create-error">{error}</div>{/if}
  <div class="field">
    <label>Name *</label>
    <input type="text" bind:value={form.name} placeholder="Artist name" maxlength="250" />
  </div>
  <div class="inline-create-row">
    <div class="field">
      <label>Formed Year</label>
      <input type="number" bind:value={form.formed_year} placeholder="e.g. 2019" min="1940" max="2999" />
    </div>
    <CountrySelect bind:value={form.country} />
  </div>
  <div class="field">
    <label>Status</label>
    <select bind:value={form.status}>
      <option value="">Unknown</option>
      <option value="active">Active</option>
      <option value="disbanded">Disbanded</option>
      <option value="hiatus">Hiatus</option>
    </select>
  </div>
  <div class="field">
    <label>Genres <span class="hint">comma-separated</span></label>
    <input type="text" bind:value={form.genres} placeholder="e.g. Death Metal, Black Metal" />
  </div>
  <div class="field">
    <label>Description</label>
    <textarea bind:value={form.description} placeholder="Bio or notes…" rows="3" maxlength="5000"></textarea>
  </div>
  <div class="field">
    <label>Band Logo URL</label>
    <input type="url" bind:value={form.band_logo_url} placeholder="https://…" />
  </div>
  <div class="inline-create-actions">
    <button type="button" class="btn-cancel" on:click={() => dispatch('cancel')}>Cancel</button>
    <button type="button" class="btn-submit" on:click={submit} disabled={loading}>
      {loading ? 'Creating…' : 'Create & Select'}
    </button>
  </div>
</div>

<style>
  .inline-create-form {
    padding: 0.85rem; background: #060e00; border-top: 1px solid #1e3d00;
    animation: slideIn 0.15s ease;
  }
  @keyframes slideIn {
    from { opacity: 0; transform: translateY(-4px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .inline-create-header {
    display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.75rem;
    font-family: 'Rajdhani', sans-serif; font-weight: 700; font-size: 0.55rem;
    letter-spacing: 0.3em; text-transform: uppercase; color: #3a6b00;
  }
  .inline-create-close {
    background: none; border: none; color: #2a5200; cursor: pointer;
    font-size: 0.8rem; padding: 0; line-height: 1; transition: color 0.15s;
  }
  .inline-create-close:hover { color: #cc4400; }
  .inline-create-error {
    background: rgba(204,68,0,0.1); border: 1px solid rgba(204,68,0,0.3); border-radius: 2px;
    color: #cc6633; font-family: 'Rajdhani', sans-serif; font-size: 0.6rem;
    letter-spacing: 0.08em; padding: 0.45rem 0.6rem; margin-bottom: 0.75rem;
  }
  .inline-create-row { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; }
  .inline-create-actions { display: flex; gap: 0.5rem; margin-top: 0.25rem; }
  .btn-cancel {
    flex: 0 0 auto; background: none; border: 1px solid #1e3d00; border-radius: 2px;
    color: #2a5200; font-family: 'Rajdhani', sans-serif; font-weight: 700;
    font-size: 0.6rem; letter-spacing: 0.22em; text-transform: uppercase;
    padding: 0.75rem 1rem; cursor: pointer; transition: color 0.15s, border-color 0.15s;
  }
  .btn-cancel:hover { color: #cc4400; border-color: #4a1000; }
  .btn-submit {
    flex: 1; background: #1a3300; border: 1px solid #3a6b00; color: #6db800;
    font-family: 'Rajdhani', sans-serif; font-weight: 700; font-size: 0.6rem;
    letter-spacing: 0.28em; text-transform: uppercase; padding: 0.75rem;
    cursor: pointer; border-radius: 2px; transition: background 0.2s, box-shadow 0.2s;
  }
  .btn-submit:hover { background: #223d00; box-shadow: 0 0 12px rgba(109,184,0,0.3); }
  .btn-submit:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
